import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IReferenceDataModel } from '../models/veg-wizard-models';

@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService {

  constructor(private http: HttpClient) {
  }

  getStates$(): Observable<IReferenceDataModel[]> {
    const url = `${environment.apiUrl}/look-up-references/states`;
    const results = this.http.get<IReferenceDataModel[]>(url);
    return results;
  }

  getCountries$(): Observable<IReferenceDataModel[]> {
    const url = `${environment.apiUrl}/look-up-references/countries`;
    return this.http.get<IReferenceDataModel[]>(url);
  }
}
